import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
import "../../TargetReport/TableContent/index.css";
import { useMessageBox } from "../../../../context/MessageBox";
import { toast } from "react-toastify";
import Loading from '../../../../components/Loading';
import StringBox from './Filters/stringBox';
import IntegerBox from './Filters/integerBox';
import DecimalBox from './Filters/decimalBox';
import PercentBox from './Filters/percentBox';
import MoneyBox from './Filters/moneyBox';
import DropDownBox from './Filters/dropDownBox';
import ComboBox from './Filters/comboBox';
import DateBox from './Filters/dateBox';
import DateTimeBox from './Filters/dateTimeBox'
import AnchorsLogoOptions from "./Filters/AnchorsLogoOptions";

function OperationsFilter({
    filterData,
    setIsLoading,
    isLoading,
    setValidList,
    setAvisosValidations,
    setValoresRespostas,
    valoresRespostas,
    filterRenderData,
    selectedAnchor,
    setSelectedAnchor
}) {
  const [loadingInicial, setLoadingInicial] = useState(true);
  const [valoresOpcoes, setValoresOpcoes] = useState([]);
  const [valoresOnLoad, setValoresOnLoad] = useState([]);
  const [disabledList, setDisabledList] = useState([]);

  const { setMessageData } = useMessageBox();

  const convertDate = (dateString) => {
    let dateArray = dateString.split('/');
    return new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
  }
  const convertDateTime = (dateString) => {
    const [date, time] = dateString.split(' ');
    const [DD, MM, YYYY] = date.split('/');
    const [HH, mm] = time.split(':');
    return new Date(YYYY, MM - 1, DD, HH, mm)
  }

  const handleInputChange = async (event, ordem, value, conteudoOnChange) => {
    
    setValoresRespostas((inputs) => ({
      ...inputs,
      [ordem]: value || '',
    }));

    if(conteudoOnChange) {
        const filtrosOrdem = conteudoOnChange.OrdemFiltro.split(';');
        if(conteudoOnChange.Acao === 'Load'){
            setIsLoading(true)
            let data = await Promise.all(filtrosOrdem.map(async(newFilter) => {
                let valoresNovos = valoresOnLoad[newFilter]
                const indexNovo = valoresNovos.findIndex(x => {return x.ordem === ordem})
                valoresNovos[indexNovo].value = value

                setValoresOnLoad((values) => ({
                    ...values,
                    [newFilter]: valoresNovos,
                }));
                const filterToChangeIndex = filterData.findIndex(x => {return x.ordem === Number(newFilter)})
                const filterToChange = filterData[filterToChangeIndex]
                const checkValues = valoresNovos.find(x => x.value === '')
                if(!checkValues) {
                    let url = filterToChange.componenteEndPoint;
                    valoresNovos.map((valorNovo) => {
                        url = url.replace(valorNovo.name, valorNovo.value)
                    })
                    await fetchOpcoes(url,  filterToChange.ordem, filterToChange.componenteType, filterToChange.componenteOnChange,filterToChange.componenteDefault, filterToChange)
                }
            }))
            setIsLoading(false)
        } else if(conteudoOnChange.Acao === 'Disable') {
            filtrosOrdem.map((newFilter) => {
                setDisabledList((disableds) => ({
                    ...disableds,
                    [Number(newFilter)]: true
                }))
                setValoresRespostas((inputs) => ({
                    ...inputs,
                    [Number(newFilter)]:  '',
                }));
            })
        }
    }
  };

  const handleInputAnchorChange = async (ordem, value, conteudoOnChange) => {
    setSelectedAnchor(value)
   setValoresRespostas((inputs) => ({
     ...inputs,
     [ordem]: {
        ancoraId: value.ancoraId ? value.ancoraId : 0,
        plataformaId: value.plataformaId ? value.plataformaId : 0
     }
   }));

   if(conteudoOnChange) {
       const filtrosOrdem = conteudoOnChange.OrdemFiltro.split(';');
       if(conteudoOnChange.Acao === 'Load'){
           setIsLoading(true)
           let data = await Promise.all(filtrosOrdem.map(async(newFilter) => {
                if(valoresOnLoad[newFilter]) {
                    let valoresNovos = valoresOnLoad[newFilter]
                    const indexNovo = valoresNovos.findIndex(x => {return x.ordem === ordem})
                    valoresNovos[indexNovo].value = `ancoraId=${value.ancoraId ? value.ancoraId : 0}&plataformaId=${value.plataformaId ? value.plataformaId : 0}`
    
                    setValoresOnLoad((values) => ({
                        ...values,
                        [newFilter]: valoresNovos,
                    }));
                }
               const filterToChangeIndex = filterData.findIndex(x => {return x.ordem === Number(newFilter)})
               const filterToChange = filterData[filterToChangeIndex]
                let url = filterToChange.componenteEndPoint;
                url = url.replace('@AncoraId', value.ancoraId ? value.ancoraId : 0).replace('@PlataformaId', value.plataformaId ? value.plataformaId : 0)
                await fetchOpcoes(url,  filterToChange.ordem, filterToChange.componenteType, filterToChange.componenteOnChange, filterToChange.componenteDefault, filterToChange)
           }))
           setIsLoading(false)
       } else if(conteudoOnChange.Acao === 'Disable') {
           filtrosOrdem.map((newFilter) => {
               setDisabledList((disableds) => ({
                   ...disableds,
                   [Number(newFilter)]: true
               }))
               setValoresRespostas((inputs) => ({
                   ...inputs,
                   [Number(newFilter)]:  '',
               }));
           })
       }
   }
 };

  const handleDateChange = async (ordem, value, conteudoOnChange) => {
    setValoresRespostas((inputs) => ({
      ...inputs,
      [ordem]: value || '',
    }));

    if(conteudoOnChange) {
        const filtrosOrdem = conteudoOnChange.OrdemFiltro.split(';');
        if(conteudoOnChange.Acao === 'Load'){
            setIsLoading(true)
            let data = await Promise.all(filtrosOrdem.map(async(newFilter) => {
                let valoresNovos = valoresOnLoad[newFilter]
                const indexNovo = valoresNovos.findIndex(x => {return x.ordem === ordem})
                valoresNovos[indexNovo].value = value

                setValoresOnLoad((values) => ({
                    ...values,
                    [newFilter]: valoresNovos,
                }));

                const filterToChangeIndex = filterData.findIndex(x => {return x.ordem === Number(newFilter)})
                const filterToChange = filterData[filterToChangeIndex]
                const checkValues = valoresNovos.find(x => x.value === '')
                if(!checkValues) {
                    let url = filterToChange.componenteEndPoint;
                    valoresNovos.map((valorNovo) => {
                        url = url.replace(valorNovo.name, valorNovo.value)
                    })
                    await fetchOpcoes(url,  filterToChange.ordem, filterToChange.componenteType, filterToChange.componenteOnChange, filterToChange.componenteDefault, filterToChange)
                }
            }))
            setIsLoading(false)
        } else if(conteudoOnChange.Acao === 'Disable') {
            filtrosOrdem.map((newFilter) => {
                setDisabledList((disableds) => ({
                    ...disableds,
                    [Number(newFilter)]: true
                }))
                setValoresRespostas((inputs) => ({
                    ...inputs,
                    [Number(newFilter)]:  '',
                }));
            })
        }
    }
  };

  const retornaComponente = (filtro, index) => {
    let valueId = ''
    let descricaoComponente = ''
    if(filtro.componenteFieldResult) {
        valueId = filtro.componenteFieldResult;
    }
    if(filtro.componenteDisplay) {
        descricaoComponente = filtro.componenteDisplay;
    }
    let zeroValue = '0'
    let mascaraArray = ''
    let casasDecimais = 0;
    let conteudoOnChange = null;
    if(filtro.componenteOnChange) {
        conteudoOnChange = JSON.parse(filtro.componenteOnChange);
    }
    switch (filtro.componenteType) {
        case 'DropDown':
            return(
                <DropDownBox
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleInputChange={handleInputChange}
                    valoresRespostas={valoresRespostas}
                    isLoading={isLoading}
                    valoresOpcoes={valoresOpcoes[filtro.ordem]}
                    valueId={valueId}
                    descricaoComponente={descricaoComponente}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
        case 'StringBox':
            return(
                <StringBox
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleInputChange={handleInputChange}
                    valoresRespostas={valoresRespostas}
                    mascara={filtro.componenteMask}
                    isLoading={isLoading}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
        case 'IntegerBox':
            return(
                <IntegerBox
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleInputChange={handleInputChange}
                    valoresRespostas={valoresRespostas}
                    isLoading={isLoading}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
        case 'ComboBox':
            const opcoesComboBox = JSON.parse(filtro.componenteValues)
            return(
                <ComboBox
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleInputChange={handleInputChange}
                    valoresRespostas={valoresRespostas}
                    isLoading={isLoading}
                    opcoesComboBox={opcoesComboBox.length > 0 ? opcoesComboBox : []}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
        case 'DateBox':
            return(
                <DateBox
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleDateChange={handleDateChange}
                    valoresRespostas={valoresRespostas}
                    isLoading={isLoading}
                    dateFormat={filtro.componenteMask ? filtro.componenteMask : 'dd/MM/yyyy'}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
        case 'MoneyBox':
            return(
                <MoneyBox
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleInputChange={handleInputChange}
                    valoresRespostas={valoresRespostas}
                    isLoading={isLoading}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
        case 'DecimalBox':
            zeroValue = filtro.componenteMask.replace('.', ',')
            mascaraArray = filtro.componenteMask.split('.')
            casasDecimais = mascaraArray[1] ? mascaraArray[1].length : 0;
            return(
                <DecimalBox
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleInputChange={handleInputChange}
                    valoresRespostas={valoresRespostas}
                    decimalPlaces={casasDecimais}
                    zeroValue={zeroValue}
                    isLoading={isLoading}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
        case 'PercentBox':
            zeroValue = filtro.componenteMask.replace('.', ',')
            mascaraArray = filtro.componenteMask.split('.')
            casasDecimais = mascaraArray[1] ? mascaraArray[1].length : 0;
            return(
                <PercentBox
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleInputChange={handleInputChange}
                    valoresRespostas={valoresRespostas}
                    decimalPlaces={casasDecimais}
                    zeroValue={zeroValue}
                    isLoading={isLoading}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
        case 'DateTimeBox':
            return(
                <DateTimeBox
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleDateChange={handleDateChange}
                    valoresRespostas={valoresRespostas}
                    isLoading={isLoading}
                    dateFormat={filtro.componenteMask ? filtro.componenteMask : 'dd/MM/yyyy HH:mm'}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
        case 'AncorasPlataformasBox':
            return(
                <AnchorsLogoOptions
                    valoresOpcoes={valoresOpcoes}
                    selectedAnchor={selectedAnchor}
                    title={filtro.titulo}
                    filterName={filtro.sqlParametroCampo}
                    handleInputChange={handleInputAnchorChange}
                    isLoading={isLoading}
                    ordem={filtro.ordem}
                    conteudoOnChange={conteudoOnChange}
                    disabledList={disabledList}
                    componenteWidth={filtro.componenteWidth}
                />
            )
    }
  }

  const fetchOpcoes = async (url, index, type, conteudoOnChange, valorDefault, filtro) => {
    let opcoes = valoresOpcoes;
    url = url.replace('/v1/', '/')
    if(valorDefault !== null) {
        setValoresRespostas((inputs) => ({
            ...inputs,
            [index]: valorDefault || '',
          }));
    }
    try {
        const relatorios = await api.get(url)
        if (relatorios?.data?.complemento?.mensagensBox?.length > 0) {
            setMessageData(relatorio?.data?.complemento?.mensagensBox);
        }

        if (relatorios?.data?.status !== "Sucesso") {
            if (relatorio.data.resposta) {
                if (relatorio.data.resposta.length > 0) {
                    relatorio.data.resposta.forEach((element) => {
                        toast.error(element.message);
                    });
                }
            }
        }

        if(relatorios && relatorios.data && relatorios.data.status == 'Sucesso') {
            if(type === 'AncorasPlataformasBox') {
                let defaultAnchor = 0;
                if(relatorios.data.resposta.redeCapittale) {
                    defaultAnchor = relatorios.data.resposta.redeCapittale
                } else if (relatorios.data.resposta.redes && relatorios.data.resposta.redes.length > 0) {
                    defaultAnchor = relatorios.data.resposta.redes[0]
                } else if (relatorios.data.resposta.plataformas && relatorios.data.resposta.plataformas.length > 0) {
                    defaultAnchor = relatorios.data.resposta.plataformas[0]
                } else {
                    defaultAnchor = relatorios.data.resposta[0]
                }
                setSelectedAnchor(defaultAnchor)
                opcoes[index] = relatorios.data.resposta;
                setValoresOpcoes(opcoes)

                await handleInputAnchorChange(index, defaultAnchor, conteudoOnChange ? JSON.parse(conteudoOnChange) : null)
            } else {
                const opcoesDefault = JSON.parse(filtro.componenteValues)
                let arrayTemp = [];
                opcoesDefault.map((x) => {
                    let option = {value: x.Id , label: x.Informacao};
                    arrayTemp.push(option)
                })
                relatorios.data.resposta.map((x) => {
                    let option = {value: x[filtro.componenteFieldResult] , label: x[filtro.componenteDisplay]};
                    arrayTemp.push(option)
                })
                opcoes[index] = arrayTemp;
                setValoresOpcoes(opcoes)
            }
        }
      } catch (err) {
        opcoes[index] = [];
        setValoresOpcoes(opcoes)
      }
  }

  useEffect(() => {
    const initializeLoad = async () => {
        setValoresOpcoes([]);
        setValoresRespostas([]);
        setValoresOnLoad([]);
        setDisabledList([]);

        let onLoadArray = [];
        let valoresIniciais = []
        let disabledIniciais = []
        setLoadingInicial(true)
        let data = await Promise.all(filterData.map(async (filter, index) => {
            if(filter.componenteOnChange) {
                const conteudo = JSON.parse(filter.componenteOnChange);
                const filtrosOrdem = conteudo.OrdemFiltro.split(';');
                if(conteudo.Acao === 'Load'){
                    filtrosOrdem.map((newFilter) => {
                        if(onLoadArray[Number(newFilter)]){ 
                            let newValues = onLoadArray[Number(newFilter)];
                            let valueDefault = filter.componenteType !== 'DateBox' && filter.componenteType !== 'DateTimeBox' ? filter.componenteDefault : ''
                            newValues.push({name: filter.sqlParametroCampo, value: valueDefault, ordem: filter.ordem})
                            onLoadArray[Number(newFilter)] = newValues
                        } else {
                            let valueDefault = filter.componenteType !== 'DateBox' && filter.componenteType !== 'DateTimeBox' ? filter.componenteDefault : ''
                            onLoadArray[Number(newFilter)] = [{name: filter.sqlParametroCampo, value: valueDefault, ordem: filter.ordem}]
                        }
                    })
                }
            }
            if(filter.componenteEndPoint && !onLoadArray[filter.ordem]) {
                const url = filter.componenteEndPoint
                await fetchOpcoes(url, filter.ordem, filter.componenteType, filter.componenteOnChange, null, filter)
            } else {
                let opcoes = valoresOpcoes; 
                opcoes[filter.ordem] = [];
                setValoresOpcoes(opcoes)
            }

            if(filter.componenteType === 'DateBox') {
                valoresIniciais[filter.ordem] = filter.componenteDefault && isNaN(filter.componenteDefault) ? convertDate(filter.componenteDefault) : ''
            } else if (filter.componenteType === 'DateTimeBox') {
                valoresIniciais[filter.ordem] = filter.componenteDefault && isNaN(filter.componenteDefault) ? convertDateTime(filter.componenteDefault) : ''
            } else if (filter.componenteType === 'AncorasPlataformasBox') {
                valoresIniciais[filter.ordem] = {
                    ancoraId: filter.componenteDefault,
                    plataformaId: filter.componenteDefault
                }
            } else {
                valoresIniciais[filter.ordem] = filter.componenteDefault
            }
            disabledIniciais[filter.ordem] = false
        }))
        setValoresOnLoad(onLoadArray)
        setValoresRespostas(valoresIniciais)
        setDisabledList(disabledIniciais)
        setLoadingInicial(false)
    };
    initializeLoad();
  }, []);

  return (
    <>
      <div style={{ height: "100%", width:'100%' }}>
        <div
          className='new-body-schedule'
          style={{
            marginTop: "20px",
          }}>
          <p></p>
          <div>
            {loadingInicial ? (
                <Loading />
            ) : (
                <>
                    {filterRenderData.map((item, indexRender) => (
                        <div key={indexRender} style={{ display: 'flex', width: '100%' }}>
                            {item?.length > 0 && (
                                <>
                                    {item.map((filter, index) => (
                                        <div key={index} style={{ width: 'min-content', marginRight: '15px' }}>
                                        {retornaComponente(filter, index)}
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    ))}
                </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default OperationsFilter;
